import { Suspense, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Navbar, Topbar } from "../cpn/navbar";
import { useDispatch, useSelector } from "react-redux";
import LoadingPage from "../Components/Loading";
import { getFromIndexedDB, saveToIndexedDB } from "../utils/indexedDB";
import useCheckPrivilege from "../Hooks/useCheckPrivilege";
import PageNotFound from "./notfound";

export default function RootLayout() {
  const {
    lang,
    proxy,
    page,
    pages,
    socket,
    auth: { ct = [], role },
  } = useSelector((state) => state);
  const dispatch = useDispatch();

  const _token = localStorage.getItem("_token");
  const stringifiedUser = localStorage.getItem("user");
  const username = stringifiedUser ? JSON.parse(stringifiedUser) : "";
  const url = window.location.pathname.slice(1);
  const [isLoading, setLoading] = useState(true);

  const fetchAndSetTablesVsFields = async (tables, fields) => {
    dispatch({
      branch: "db",
      type: "initializeData",
      payload: { tables, fields },
    });
  };

  const fetchFreshData = async () => {
    const response = await fetch(`${proxy()}/apis/all/tables/and/fields`, {
      headers: {
        Authorization: _token,
      },
    });
    const { success, data } = await response.json();

    if (success && data) {
      const { tables, fields } = data;
      await saveToIndexedDB("fields", fields);
      await saveToIndexedDB("tables", tables);
      await fetchAndSetTablesVsFields(tables, fields);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (url === "check" || url === "logs") {
        return;
      }
      // setLoading(true);
      try {
        const cachedFields = await getFromIndexedDB("fields");
        const cachedTables = await getFromIndexedDB("tables");

        if (cachedFields.length > 0 && cachedTables.length > 0) {
          await fetchAndSetTablesVsFields(cachedTables, cachedFields);
          setLoading(false);
          return;
        }

        const response = await fetch(`${proxy()}/apis/all/tables/and/fields`, {
          headers: {
            Authorization: _token,
          },
        });
        const resp = await response.json();

        const { success, data } = resp;
        if (success && data) {
          const { tables, fields } = data;
          await saveToIndexedDB("fields", fields);
          await saveToIndexedDB("tables", tables);
          await fetchAndSetTablesVsFields(tables, fields);
        }
      } catch (error) {
        console.error("Error", error);
      } finally {
        setLoading(false);
      }
    };

    const handleDBUpdate = async () => {
      await saveToIndexedDB("fields", []);
      await saveToIndexedDB("tables", []);
      fetchFreshData();
      // window.location.reload();
    };

    socket.on("/dipe-production-import-db", handleDBUpdate);

    fetchData();

    // const intervalId = setInterval(() => {
    //   if (url !== "check" && url !== "logs") {
    //     fetchFreshData();
    //   }
    // }, 300000);

    // window.onload = () => {
    //   fetchFreshData();
    // };

    return () => {
      // clearInterval(intervalId);
      socket.off("/dipe-production-import-db", handleDBUpdate);
    };
  }, [url]);

  useEffect(() => {
    const isTabOpened = sessionStorage.getItem("newTablesVsFields");

    if (!isTabOpened) {
      fetchFreshData();
      window.sessionStorage.setItem("newTablesVsFields", "true");
    }
  }, []);

  const PAGE = flatteningPages(pages).find(
    (p) => p.page_id === url || url.includes(p.page_id)
  );

  const hasPrivilege = useCheckPrivilege(PAGE);
  const { page_id, state } = hasPrivilege;

  return (
    <Suspense fallback={<LoadingPage left="55%" />}>
      <Navbar is_public={page?.is_public} pages={pages} />
      <Topbar is_public={page?.is_public} />
      <div id="content">
        {state ? <Outlet /> : page_id ? <Navigate to={`/${page_id}`} /> : null}
      </div>
    </Suspense>
  );
}

const flatteningPages = (pages) => {
  const pgs = [];
  for (let i = 0; i < pages.length; i++) {
    // if (!pages[i]?.is_hidden) {
    pgs.push({ ...pages[i], children: [] });
    if (pages[i].children) {
      pgs.push(...flatteningPages(pages[i].children));
    }
    // }
  }
  return pgs;
};
